<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
	@import '~normalize.css/normalize.css';// normalize.css 样式格式化
	@import './styles/index.scss'; // 全局自定义的css样式
	@import './styles/common.css'; // 全局公共样式
</style>



// WEBPACK FOOTER //
// src/App.vue?427fd880